export const CANONICAL_SITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL || 'https://theqream.com';
export const SITE_NAME = 'Qream';
export const TWITTER_SITE = '@qream_design';
export const TWITTER_CARD = 'summary_large_image' as const;

export const DEFAULT_OG_IMAGE = {
	url: `${CANONICAL_SITE_URL}/common-open-graph.jpg`,
	width: 2400,
	height: 1260,
	alt: 'Qream Open Graph Image'
};

export const DEFAULT_SITE_TITLE = 'Digital design transformation agency | Qream';
export const DEFAULT_SITE_DESCRIPTION =
	'Qream is a digital strategy and design transformation agency creating standout websites and brand identities for tech gamechangers.';
